export const formatLocationString = (locationName: string): string | null => {
  const [prefix, suffix] = locationName.split(' - ');
  return suffix && prefix ? `${suffix}, ${prefix}` : null;
};
